import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d69ba6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order-details-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Order Summary:", -1))
const _hoisted_3 = { class: "details" }
const _hoisted_4 = { class: "item-card" }
const _hoisted_5 = { class: "item-card-preview" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "item-card-details" }
const _hoisted_9 = { class: "item-card-details-name" }
const _hoisted_10 = { class: "actions-dropdown-container" }
const _hoisted_11 = { class: "item-card-details-total" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "ITEM TOTAL:", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_14 = { class: "total-amount" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Subtotal", -1))
const _hoisted_16 = { class: "total-amount" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Shipping", -1))
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-spin pi-spinner",
  style: {"font-size":"1rem"}
}, null, -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { key: 2 }
const _hoisted_23 = { class: "total-amount" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "GST", -1))
const _hoisted_25 = { class: "total-amount" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Total", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderedItems, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "card-wrapper",
          key: item.id
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", {
                class: "item-card-image",
                innerHTML: _ctx.parser(item.imageFront)
              }, null, 8, _hoisted_6),
              _createElementVNode("div", {
                class: "item-card-preview-edit",
                onClick: ($event: any) => (_ctx.editDesign(item))
              }, " EDIT DESIGN ", 8, _hoisted_7)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.getLabel(item.alias)), 1),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", null, "QTY: " + _toDisplayString(item.quantity), 1)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("div", null, " $" + _toDisplayString(_ctx.getItemPrice(item.price, item.quantity, item.addons)), 1)
              ])
            ])
          ]),
          _hoisted_13
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_14, [
      _hoisted_15,
      _createElementVNode("div", null, "$" + _toDisplayString(_ctx.getSubTotalPrice(true)), 1)
    ]),
    _createElementVNode("div", _hoisted_16, [
      _hoisted_17,
      (!_ctx.shippingPrice && _ctx.shippingPrice !== 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, "----"))
        : (_ctx.shippingPrice === 'loading')
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21))
          : (_openBlock(), _createElementBlock("div", _hoisted_22, "$" + _toDisplayString(_ctx.shippingPriceComputed), 1))
    ]),
    _createElementVNode("div", _hoisted_23, [
      _hoisted_24,
      _createElementVNode("div", null, "$" + _toDisplayString(_ctx.gstPrice), 1)
    ]),
    _createElementVNode("div", _hoisted_25, [
      _hoisted_26,
      _createElementVNode("div", null, "$" + _toDisplayString(_ctx.fullPrice) + " AUD", 1)
    ])
  ]))
}